module.exports = __webpack_public_path__ + "img/77.7de3927f.jpg";